import { BasePageContent } from "../../../../core/content/base-page-content.component";

export class PagecontentSearchResultUSTCRPage extends BasePageContent {
  getPageSpecificText() {
    this.PAGE_TEXT["lust"] = {
      lbl_return: "RETURN TO SEARCH",

      lbl_ltf: `LTF ID#:`,
      lbl_date_submit: `Date Submitted:`,
      lbl_ltf_status: `LTF Status:`,

      lbl_permit_info: `Permit Information`,
      lbl_permit_type: `Permit Type:`,
      lbl_date_applied: `Date Applied:`,
      lbl_project_type: `Project Type:`,

      lbl_owner_name: `Owner:`,
      lbl_company_name: `Company Name:`,
      lbl_company_address: `Company Address:`,

      lbl_date_issued: `Issue Date:`,
      lbl_authcode: `Authorization Code:`,

      lbl_const_info: `Construction Information`,
      lbl_date_start: `Start Date:`,
      lbl_date_end: `End Date:`,
      lbl_common_area: `Common Area:`,

      lbl_siteName: `Project/Site Name:`,
      lbl_facility_name: `Facility Name:`,
      lbl_facility_address: `Facility Address:`,
      lbl_facility_county: `County:`,

      lbl_outfalls: `Outfalls:`,
      lbl_total_proj_area: `Total Area (in acres):`,
      lbl_permit_proj_area: `Project Area (in acres):`,

      lbl_swwp_info: `SWPPP Information`,
      lbl_contact: `Contact Name:`,
      // lbl_email: `Email:`,
      lbl_phone: `Phone:`,

      lbl_lat: `Latitude`,
      lbl_lng: `Longitude`,

      lbl_history: `HISTORY`,
      lbl_pm_header: `Project Manager (PM) Information`,
      lbl_pm_name: `Manager Name:`,
      lbl_email: `Email:`,

      lbl_leaking_ust_info_header: `Leaking UST Information`,
      lbl_merge_release: `MERGE RELEASES`,
      lbl_res_release_confirm: `RESCIND RELEASE CONFIRMATION`,
      lbl_init_closure: `INITIATE CLOSURE`,
      lbl_rel_confim_date: `Release Confirmation Date:`,

      lbl_rel_report_date: `Release Reported Date:`,
      lbl_ust_assing_date: `Leaking UST Assigned Date:`,

      lbl_product_discovery_date: `Free Product Discovery Date:`,
      lbl_dept_to_water: `Depth to Water (ft):`,
      lbl_receptor_impacted: `Receptor Impacted:`,

      lbl_char_date: `Characterization Date:`,
      lbl_est_closure_date: `Estimated Closure Date:`,
      lbl_case_closure_date: `Case Closure Date:`,

      lbl_priority: `Priority Code:`,
      lbl_classification: `Classification:`,
      lbl_program: `Program:`,
      subtext: `For more information, please contact the ADEQ records center at 602-771-4380 or go to`,

      lbl_case: `Leaking UST Case#`,
      lbl_fac: `Facility ID#`,
      lbl_company: `Company Name:`,
      lbl_fac_nm: `Facility Name:`,
      lbl_county: `Facility County:`,
      lbl_address: `Facility Address`,
      lbl_confirm_dt: "Confirmation Date",
      lbl_status: `Status`,
      lbl_act: "Action",
      lbl_search: `SEARCH`,
      lbl_search_all: `VIEW ALL`,
      return_btn: "RETURN TO ADEQ WEBSITE",

      col_prod: "Products Associated With The Release",
      col_media: "Media Impacted",
      lbl_remed: "Remediation Information:",
      col_med: "Medium Being Remediated;",
      col_rem_method_cat: "Remedial Method Category",
      col_rem_method_sub_cat: "Remedial Method Subcategory",
    };
  }
}
